// ----------------------------------------------------------------------

const MuiStack = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    useFlexGap: true,
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const stack = {
  MuiStack,
};
